import { MatterFileType } from '@models/matter';

export interface TagMapping {
	/**
	 * @description The tag name without curly brackets
	 */
	tag: string;
	hideFromProduction?: boolean; //doesnt exist if false
	categories: string[]; //in order of levelOne, levelTwo, levelThree, levelFour
	defaultValue?: string;
	description?: string;
	fileType?: MatterFileType[]; //doesnt exist if all file types
}

export const PurchaseRefinance = [
	MatterFileType.PURCHASE,
	MatterFileType.REFINANCE,
];
export const PurchaseSale = [MatterFileType.PURCHASE, MatterFileType.SALE];
export const SaleRefinance = [MatterFileType.SALE, MatterFileType.REFINANCE];
export const Refinance = [MatterFileType.REFINANCE];
export const Purchase = [MatterFileType.PURCHASE];
export const Sale = [MatterFileType.SALE];

export const TagsMapping: TagMapping[] = [
	{
		tag: 'appointmentDate',
		categories: ['Appointment '],
		description: 'The appointment date as entered into the Key Dates',
	},
	{
		tag: 'appointmentLongDate',
		categories: ['Appointment '],
		description:
			'The appointment date as entered into the Key Dates, formatted "this (day) day of (month), (year). Default is current month and year',
	},
	{
		tag: 'appointmentTime',
		categories: ['Appointment '],
		description:
			'The time of the appointment as entered into the Key Dates eg 9:00AM',
	},
	{
		tag: 'commissioner.name',
		categories: ['Appointment '],
		description: 'commissioner name as entered into Key Dates',
	},
	{
		tag: 'executingAddress.city',
		categories: ['Appointment '],
		description: 'The Location as shown in Office Settings',
	},
	{
		tag: 'executingAddress.province',
		categories: ['Appointment '],
		description: 'The Region as shown in Office Settings',
	},
	{
		tag: 'executingAddress.locationType',
		categories: ['Appointment '],
		description: 'The Location Specified as shown in Office Settings',
	},
	{
		tag: 'executingAddress.regionType',
		categories: ['Appointment '],
		description: 'The Region Specified as shown in Office Settings',
	},
	{
		tag: 'officeExecutingAddress.location',
		categories: ['Appointment '],
		description: 'The Location as entered into Office Settings',
	},
	{
		tag: 'officeExecutingAddress.region',
		categories: ['Appointment '],
		description: 'The Region as entered into Office Settings',
	},
	{
		tag: 'officeExecutingAddress.locationType',
		categories: ['Appointment '],
		description: 'The Location Specified as entered into Office Settings',
	},
	{
		tag: 'officeExecutingAddress.regionType',
		categories: ['Appointment '],
		description: 'The RegionSpecified as entered into Office Settings',
	},
	{
		tag: 'clientExecutingAddress.location',
		categories: ['Appointment '],
		description: 'The Location as entered into Key Dates',
	},
	{
		tag: 'clientExecutingAddress.region',
		categories: ['Appointment '],
		description: 'The Region as entered into Key Dates',
	},
	{
		tag: 'clientExecutingAddress.locationType',
		categories: ['Appointment '],
		description: 'The Location Specified as entered into Key Dates',
	},
	{
		tag: 'clientExecutingAddress.regionType',
		categories: ['Appointment '],
		description: 'The Region Specified as entered into Key Dates',
	},
	{
		tag: 'executingDate',
		categories: ['Appointment '],
		description: 'Appointment Date as entered into Key Dates',
	},
	{
		tag: 'remoteSigningJurat',
		categories: ['Appointment '],
		description:
			'The jurat for remote signing as shown in business settings.  Can also be used for logic',
	},
	{
		tag: 'inPersonSigningJurat',
		categories: ['Appointment '],
		description:
			'The jurat for in person signing as shown in business settings.  Can also be used for logic',
	},
	{
		tag: 'witness.name',
		categories: ['Appointment '],
		description: 'Name of the Witness as entered into the Key Dates.',
	},
	{
		tag: 'signingLine.dateSigned',
		categories: ['Appointment '],
		description: `The Date of signing for the firm's clients.`,
	},
	{
		tag: 'signingLine.dateSignedDraft',
		categories: ['Appointment '],
		description: `The Date of signing for the other party law firm's clients.`,
	},
	{
		tag: 'clients.associatedNames',
		categories: ['Client', 'General', 'Associated'],
		description:
			"All associated clients on the file, including their POA's, Trustees, and Signing Officers",
	},
	{
		tag: 'clients.associatedNamesTitles',
		categories: ['Client', 'General', 'Associated'],
		description:
			"All associated clients on the file, including their POA's, Trustees, and Signing Officers with any Titles/Honorifics assigned to them (Mr. Ms. etc)",
	},
	{
		tag: 'clients.consentingSpouses.count',
		categories: ['Client', 'General', 'Consenting Spouse'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.consentingSpouses.names',
		categories: ['Client', 'General', 'Consenting Spouse'],
		description:
			"names of consenting spouses, with a comma between and 'and' before the last",
	},
	{
		tag: 'clients.consentingSpouses',
		categories: ['Client', 'General', 'Consenting Spouse'],
		description: 'true/false',
		hideFromProduction: true,
	},
	{
		tag: 'signatureLine.consentingSpouses',
		categories: ['Client', 'General', 'Consenting Spouse'],
		description:
			"signature line right across the page / cell, with name of spouse and, beneath that, 'Consenting Spouse of XXX'",
	},
	{
		tag: 'signatureBlock.consentingSpousesWithWitnesses',
		categories: ['Client', 'General', 'Consenting Spouse'],
	},
	{
		tag: 'signatureBlock.consentingSpouses',
		categories: ['Client', 'General', 'Consenting Spouse'],
	},
	{
		tag: 'clients.capacityOfOwnership.name',
		categories: ['Client', 'General'],
		description:
			"The clients' capacity of ownership type name as entered into the Parties Page",
		fileType: PurchaseRefinance,
	},
	{
		tag: 'clients.capacityOfOwnership.type.capacityPerClient',
		categories: ['Client', 'General'],
		description: 'lists whatever is in Capacity of Ownership',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'clients.capacityOfOwnership.type.jointTenants',
		categories: ['Client', 'General'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'clients.capacityOfOwnership.type.registeredOwner',
		categories: ['Client', 'General'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'clients.capacityOfOwnership.type.silent',
		categories: ['Client', 'General'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'clients.capacityOfOwnership.type.tenantsInCommon',
		categories: ['Client', 'General'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'clients.count',
		categories: ['Client', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.lastNames.unique',
		categories: ['Client', 'General'],
		description:
			"Client's last names that will only populate unique last names and not same last names. ",
	},
	{
		tag: 'clients.lastNames',
		categories: ['Client', 'General'],
		description:
			"Client's last names, including any duplicate names, with a comma 'and' before the last name",
	},
	{
		tag: 'clients.names',
		categories: ['Client', 'General'],
		description:
			"full  names of clients, including middle names, with a comma and 'and' before last name",
	},
	{
		tag: 'clients.namesAndAddresses.block',
		categories: ['Client', 'General'],
		description:
			"Client's full names, with their 'Report Address' beneath that.  Client's are grouped by the same addresses, ie if there are two clients at the same address, this tag will list those names with the relevant address.  Note, postal code is on a separate line",
	},
	{
		tag: 'clients.namesAndAddresses.line',
		categories: ['Client', 'General'],
		description:
			"Client's full names on one line, with the address on the next line - groupings of clients with the same address",
	},
	{
		tag: 'clients.namesAndAddresses',
		categories: ['Client', 'General'],
		description:
			"Client's full names, with their 'Report Address' beneath that.  Client's are grouped by the same addresses, ie if there are two clients at the same address, this tag will list those names with the relevant address.  Note, postal code is on a separate line",
	},
	{
		tag: 'clients.namesTitles',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.amAre',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.hasHave',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.heSheThey',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.himHerThem',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.himselfHerselfThemselves',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.hisHersTheirs',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.hisHerTheir',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.isAre',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.IWe',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.meUs',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.mineOurs',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.myOur',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.pronouns.wasWere',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.residentStatus',
		categories: ['Client', 'General'],
		description:
			"Client full name' is not a non-resident of Canada within the meaning of Section 116 of the Income Tax Act (Canada) and nor will they be a non-resident of Canada at the time of closing. ",
	},
	{
		tag: 'clients.showSpousalStatements',
		categories: ['Client', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.type.builder',
		categories: ['Client', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.type.corporation',
		categories: ['Client', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.type.person',
		categories: ['Client', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'signatureLine.clients',
		categories: ['Client', 'General'],
	},
	{
		tag: 'signatureLine.clientsNoTitle',
		categories: ['Client', 'General'],
	},
	{
		tag: 'signatureBlock.clients',
		categories: ['Client', 'General'],
	},
	{
		tag: 'signatureBlock.offerorsWithWitnesses',
		categories: ['Client', 'General'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureBlock.clientsWithWitnesses',
		categories: ['Client', 'General'],
	},
	{
		tag: 'signatureBlock.clientsNoTitle',
		categories: ['Client', 'General'],
	},
	{
		tag: 'signatureBlock.clientsWithWitnesses',
		categories: ['Client', 'General'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.count',
		categories: ['Client', 'Primary', 'Associated', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.amAre',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.hasHave',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.heSheThey',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.himHerThem',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.himselfHerselfThemselves',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.hisHersTheirs',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.hisHerTheir',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.isAre',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.IWe',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.meUs',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.mineOurs',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.myOur',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.poas.pronouns.wasWere',
		categories: ['Client', 'Primary', 'Associated', 'POA'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.count',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.amAre',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.hasHave',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.heSheThey',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.himHerThem',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.himselfHerselfThemselves',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.hisHersTheirs',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.hisHerTheir',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.isAre',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.IWe',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.meUs',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.mineOurs',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.myOur',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.signingOfficers.pronouns.wasWere',
		categories: ['Client', 'Primary', 'Associated', 'Signing Officer'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.count',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.amAre',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.hasHave',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.heSheThey',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.himHerThem',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.himselfHerselfThemselves',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.hisHersTheirs',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.hisHerTheir',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.isAre',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.IWe',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.meUs',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.mineOurs',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.myOur',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedContacts.trustees.pronouns.wasWere',
		categories: ['Client', 'Primary', 'Associated', 'Trustees'],
	},
	{
		tag: 'clients.primary.associatedName',
		categories: ['Client', 'Primary', 'Associated'],
	},
	{
		tag: 'clients.primary.associatedNameTitle',
		categories: ['Client', 'Primary', 'Associated'],
	},
	{
		tag: 'clients.primary.consentingSpouse.name',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.hasHave',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.heSheThey',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.himHerThem',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.himselfHerselfThemselves',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.hisHersTheirs',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.hisHerTheir',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.pronouns.isAre',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.signatureBlockWithWitnesses',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.birthDate',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.block',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.city',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.country',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.line',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.postcode',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.province',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.province.long',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.poBox',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.street',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.street2',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.businessAddress.unit',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Business Address'],
	},
	{
		tag: 'clients.primary.consentingSpouse.email',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.gender',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.homePhone',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.occupation',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.firstName',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.lastName',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.middleNames',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.name',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.nameTitle',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.phone',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.workPhone',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.country',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.dateOfVerification',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.displayText',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.expirationDate',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.jurisdiction',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.nameOnId',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.number',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.primary.verifiedBy',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.country',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.dateOfVerification',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.displayText',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.expirationDate',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.jurisdiction',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.nameOnId',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.number',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.identification.secondary.verifiedBy',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Identification'],
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.block',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.city',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.country',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.faxNumber',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.line.condensed',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.line',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.name',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.poBox',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.postcode',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.province.long',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.province',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.street',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.street2',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.unit',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress.website',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.reportAddress',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.block',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.city',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.country',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.faxNumber',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.line.condensed',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.line',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.name',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.poBox',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.postcode',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.province.long',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.province',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.street',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.street2',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.unit',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress.website',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.consentingSpouse.serviceAddress',
		categories: ['Client', 'Primary', 'Consenting Spouse', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.flaClient.email',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.gender',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.homePhone',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.name',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.nameTitle',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.phone',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.block',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.city',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.country',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.faxNumber',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.line.condensed',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.line',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.name',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.poBox',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.postcode',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.province.long',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.province',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.street',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.street2',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.unit',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress.website',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddress',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddressBlock',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.serviceAddressLine',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.title',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.flaClient.workPhone',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
		description: 'fla refers to consenting spouse',
	},
	{
		tag: 'clients.primary.formattedName',
		categories: ['Client', 'Primary', 'Consenting Spouse'],
	},
	{
		tag: 'clients.primary.identification.primary.country',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.dateOfVerification',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.displayText',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.expirationDate',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.jurisdiction',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.nameOnId',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.number',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.primary.verifiedBy',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.country',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.dateOfVerification',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.displayText',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.expirationDate',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.jurisdiction',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.nameOnId',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.number',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'clients.primary.identification.secondary.verifiedBy',
		categories: ['Client', 'Primary', 'Identification'],
	},
	{
		tag: 'salutations.envelope',
		categories: ['Client', 'Primary', 'Salutations'],
	},
	{
		tag: 'salutations.envelopeAdditional',
		categories: ['Client', 'Primary', 'Salutations'],
	},
	{
		tag: 'salutations.primary',
		categories: ['Client', 'Primary', 'Salutations'],
	},
	{
		tag: 'salutations.reLineClients',
		categories: ['Client', 'Primary', 'Salutations'],
	},
	{
		tag: 'salutations.reLineCondensed',
		categories: ['Client', 'Primary', 'Salutations'],
	},
	{
		tag: 'salutations.reLineGeneral',
		categories: ['Client', 'Primary', 'Salutations'],
	},
	{
		tag: 'clients.reportAddress.block',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.city',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.country',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.faxNumber',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.line.condensed',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.line',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.name',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.poBox',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.postcode',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.province.long',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.province',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.street',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.street2',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.unit',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress.website',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddress',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddressBlock',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.reportAddressLine',
		categories: ['Client', 'Primary', 'Report Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.affidavitNumbers',
		categories: ['Client', 'Primary'],
		description: 'The affidavit numbers for the primary client listed on file',
	},
	{
		tag: 'clients.primary.birthDate',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.businessAddress.block',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.city',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.country',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.faxNumber',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.line.condensed',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.line',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.name',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.poBox',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.postcode',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.province.long',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.province',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.street',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.street2',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.unit',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddress.website',
		categories: ['Client', 'Primary', 'Business Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.businessAddress',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddressBlock',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.businessAddressLine',
		categories: ['Client', 'Primary', 'Business Address'],
	},
	{
		tag: 'clients.primary.capacityOfOwnership.shares',
		categories: ['Client', 'Primary'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'clients.primary.capacityOfOwnership.type.long',
		categories: ['Client', 'Primary'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'clients.primary.capacityOfOwnership.type.short',
		categories: ['Client', 'Primary'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'clients.primary.capacityOfOwnership.type',
		categories: ['Client', 'Primary'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'clients.primary.capacityOfOwnership',
		categories: ['Client', 'Primary'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.dateOfDeath',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.email',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.estate',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.fax',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.firstName',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.gender',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.homePhone',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.id',
		categories: ['Client', 'Primary'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.instrumentNumber',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.lastName',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.summaryName',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.middleNames',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.name',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.nameTitle',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.occupation',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.offeror',
		categories: ['Client', 'Primary'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'clients.primary.phone',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.powerOfAttorney',
		categories: ['Client', 'Primary'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.resident',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.resident.status',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.resident.permanentResident',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.resident.citizen',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.hasHave',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.heSheThey',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.himHerThem',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.himselfHerselfThemselves',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.hisHersTheirs',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.hisHerTheir',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.pronouns.isAre',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.reportAddress.block',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.city',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.country',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.faxNumber',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.line.condensed',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.line',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.name',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.poBox',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.postcode',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.province.long',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.province',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.street',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.street2',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.unit',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress.website',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddress',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddressBlock',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.reportAddressLine',
		categories: ['Client', 'Primary', 'Report Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.block',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.city',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.country',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.faxNumber',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.line.condensed',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.line',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.name',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.poBox',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.postcode',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.province.long',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.province',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.street',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.street2',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.unit',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress.website',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddress',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddressBlock',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.serviceAddressLine',
		categories: ['Client', 'Primary', 'Service Address'],
	},
	{
		tag: 'clients.primary.signatureBlock',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.signatureLine',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.spousalNamesWithTitles',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.spousalStatus',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.primary.type.builder',
		categories: ['Client', 'Primary'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.type.corporation',
		categories: ['Client', 'Primary'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.type.person',
		categories: ['Client', 'Primary'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.primary.type',
		categories: ['Client', 'Primary'],
		description:
			'Notates what type of client the Primary client is. Either Person, Corporation, or Builder.',
	},
	{
		tag: 'clients.primary.workPhone',
		categories: ['Client', 'Primary'],
	},
	{
		tag: 'clients.serviceAddress.block',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.city',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.country',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.faxNumber',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.line.condensed',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.line',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.name',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.phoneNumber',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.poBox',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.postcode',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.province.long',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.province',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.street',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.street2',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.unit',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress.website',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddress',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddressBlock',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'clients.serviceAddressLine',
		categories: ['Client', 'Primary', 'Service Address'],
		hideFromProduction: true,
	},
	{
		tag: 'agreedSalePrice.amount',
		categories: ['Contract'],
		fileType: PurchaseSale,
	},
	{
		tag: 'agreedSalePrice.formatted',
		categories: ['Contract'],
		description: 'eg $500,000.00',
		fileType: PurchaseSale,
	},
	{
		tag: 'agreedSalePrice.text',
		categories: ['Contract'],
		description: 'eg Six Hundred Thousand Dollars',
		fileType: PurchaseSale,
	},
	{
		tag: 'agreedSalePrice',
		categories: ['Contract'],
		description: 'eg $60,000.00',
		fileType: PurchaseSale,
	},
	{
		tag: 'agreementDate',
		categories: ['Contract'],
	},
	{
		tag: 'agreementDate.long',
		categories: ['Contract'],
		description: 'eg 31st day of July, 2024',
	},
	{
		tag: 'agreementLongDate',
		categories: ['Contract'],
		hideFromProduction: true,
	},
	{
		tag: 'closingDate',
		categories: ['Contract'],
	},
	{
		tag: 'closingDate.long',
		categories: ['Contract'],
		description: 'eg 31st day of July, 2024',
	},
	{
		tag: 'closingLongDate',
		categories: ['Contract'],
		description: 'eg 31st day of Jul, 2024',
		hideFromProduction: true,
	},
	{
		tag: 'deposits.amount',
		categories: ['Contract'],
		description: "numerical value with no '$', comma or period ",
		fileType: PurchaseSale,
	},
	{
		tag: 'deposits.formatted',
		categories: ['Contract'],
		description: "numerical value, no '$', commas or periods eg 6000000 ",
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'deposits.text',
		categories: ['Contract'],
		fileType: PurchaseSale,
	},
	{
		tag: 'deposits',
		categories: ['Contract'],
		fileType: PurchaseSale,
	},
	{
		tag: 'keys.lockboxCode',
		categories: ['Contract'],
		fileType: PurchaseSale,
	},
	{
		tag: 'occupancyDate',
		categories: ['Contract'],
		fileType: PurchaseSale,
	},
	{
		tag: 'occupancyDate.long',
		categories: ['Contract'],
		fileType: PurchaseSale,
	},
	{
		tag: 'debts.id.payee.email',
		categories: ['Debts', 'Payee'],
	},
	{
		tag: 'debts.id.payee.fax',
		categories: ['Debts', 'Payee'],
	},
	{
		tag: 'debts.id.payee.phone',
		categories: ['Debts', 'Payee'],
	},
	{
		tag: 'debts.id.payee.workPhone',
		categories: ['Debts', 'Payee'],
	},
	{
		tag: 'debts.id.hasUndertaking',
		categories: ['Debts', 'Payee'],
		hideFromProduction: true,
	},
	{
		tag: 'debts.undertakings.id.accountNumber',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.amount.amount',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'debts.undertakings.id.amount.formatted',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'debts.undertakings.id.amount.text',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.amount',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.followUp',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.fulfillmentText',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.id',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.itemBeingPaid',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.lastNames',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.options.close',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.options.mention',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.options.receipt',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.block',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.city',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.country',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.faxNumber',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.line.condensed',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.line',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.name',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.phoneNumber',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.poBox',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.postcode',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.province.long',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.province',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.street',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.street2',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.unit',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address.website',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.address',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.addressBlock',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.addressLine',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.description',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payee.name',
		categories: ['Debts', 'Undertakings', 'Payee'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.payers.names',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.undertakings.id.reLine',
		categories: ['Debts', 'Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'debts.trustAccount.id.reLine',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.payers.names',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.payee.name',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.description',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.addressLine',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.addressBlock',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.website',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.unit',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.street2',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.street',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.province',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.province.long',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.postcode',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.poBox',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.phoneNumber',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.name',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.line',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.line.condensed',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.faxNumber',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.country',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.city',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.payee.address.block',
		categories: ['Debts', 'Trust', 'Payee '],
	},
	{
		tag: 'debts.trustAccount.id.options.receipt',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.options.mention',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.options.close',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.lastNames',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.itemBeingPaid',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.id',
		categories: ['Debts', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'debts.trustAccount.id.fulfillmentText',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.followUp',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.amount',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.amount.text',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.amount.formatted',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.amount.amount',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.trustAccount.id.accountNumber',
		categories: ['Debts', 'Trust'],
	},
	{
		tag: 'debts.length',
		categories: ['Debts'],
		description:
			"numerical value of debts ie '1' or '2' often used with If logic",
		hideFromProduction: true,
	},
	{
		tag: 'debtsFulfilledList',
		categories: ['Debts'],
		description:
			'lists debts that have been classified as fulfilled - description',
	},
	{
		tag: 'letterhead',
		categories: ['Document'],
	},
	{
		tag: 'date',
		categories: ['Document'],
		description: "Today's date",
	},
	{
		tag: 'date.long',
		categories: ['Document'],
		description: "Today's date",
	},
	{
		tag: 'document.currentPage',
		categories: ['Document'],
		description: 'The current page of the document that this tag is on.',
	},
	{
		tag: 'document.pageCount',
		categories: ['Document'],
		description: 'How many pages are within the current document.',
	},
	{
		tag: 'document.title',
		categories: ['Document'],
		description: 'The title of the document',
	},
	{
		tag: 'longDate',
		categories: ['Document'],
		description: "Today's date structured as [day] day of [month], [year].",
	},
	{
		tag: 'encumbrances.id.action',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.assume',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.attention',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.bridge',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.block',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.city',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.country',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.faxNumber',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.line.condensed',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.line',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.name',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.phoneNumber',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.poBox',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.postcode',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.province.long',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.province',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.street',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.street2',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.unit',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address.website',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.address',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.addressBlock',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.addressLine',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.email',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.faxNumber',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.name',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.phoneNumber',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawfirm.website',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawyer.email',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawyer.firstName',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawyer.lastName',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawyer.name',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lawyer.phoneNumber',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondence.lenderRELine',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.correspondenceType.mortgagee',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.correspondenceType.solicitor',
		categories: ['Encumbrances', 'Correspondence'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.discharge',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.fulfillmentText',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.id',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.institution.address.block',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.city',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.country',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.faxNumber',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.line.condensed',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.line',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'clients.primary.associatedContacts.poas.count',
		categories: ['Client', 'Primary', 'Associated', 'General'],
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.institution.address.poBox',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.postcode',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.province.long',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.province',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.street',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.street2',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.unit',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address.website',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.address',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.addressBlock',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.addressLine',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.bank',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.email',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.fax',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.name',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.institution.phone',
		categories: ['Encumbrances', 'Lender'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.instrumentNumber',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.lien',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.loanNumber',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.maturityDate',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.mortgage',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.mortgageeType',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.obtainingDischargeStatement',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.outstandingAmount.amount',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.outstandingAmount.formatted',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.outstandingAmount.text',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.outstandingAmount',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.fee.amount',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.fee.formatted',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.fee.text',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.fee',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.finalPayment.amount',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.finalPayment.formatted',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.finalPayment.text',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.finalPayment',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.interest.amount',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.interest.formatted',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.interest.text',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.interest',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalAmount.amount',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalAmount.formatted',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalAmount.text',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalAmount',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalAt',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalFrom',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.principalTo',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.paymentCalc.separateCheque',
		categories: ['Encumbrances', 'Payment Calc'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.postponementFee.amount',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.postponementFee.formatted',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.postponementFee.text',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.postponementFee',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.priority.formatted',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.priority.value',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.priority',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.registeredOnDate',
		categories: ['Encumbrances', 'Registration'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.registrationDate',
		categories: ['Encumbrances', 'Registration'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.registrationNumber',
		categories: ['Encumbrances', 'Registration'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.all.id.date',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.all.id.id',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.all.id.number',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.all.id.registrationNumber',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.all.id.type',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.id.date',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.id.id',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.id.number',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstrument.id.registrationNumber',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.id.type',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.relatedInstruments.numbers',
		categories: ['Encumbrances', 'Related Instruments'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.reLine',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.remain',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.securityInterest',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrances.id.type.name',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.type.value',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.id.undertaking',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.instrumentNumbers',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrances.length',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'encumbrancesFulfilledList',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'encumbrancesList',
		categories: ['Encumbrances'],
		fileType: SaleRefinance,
	},
	{
		tag: 'actingFor.both',
		categories: ['File'],
		fileType: Refinance,
		hideFromProduction: true,
	},
	{
		tag: 'actingFor.mortgagee',
		categories: ['File'],
		fileType: Refinance,
		hideFromProduction: true,
	},
	{
		tag: 'actingFor.mortgagor',
		categories: ['File'],
		fileType: Refinance,
		hideFromProduction: true,
	},
	{
		tag: 'notes.pinned.primary.description',
		categories: ['File'],
	},
	{
		tag: 'notes.pinned.primary.title',
		categories: ['File'],
	},
	{
		tag: 'actingFor',
		categories: ['File'],
		fileType: Refinance,
		hideFromProduction: true,
	},
	{
		tag: 'creationDate',
		categories: ['File'],
	},
	{
		tag: 'fileName',
		categories: ['File'],
	},
	{
		tag: 'fileNumber',
		categories: ['File'],
	},
	{
		tag: 'fileOpeningDate',
		categories: ['File'],
	},
	{
		tag: 'fileOpeningDate.long',
		categories: ['File'],
	},
	{
		tag: 'fileOpeningLongDate',
		categories: ['File'],
		hideFromProduction: true,
	},
	{
		tag: 'fileType.purchase',
		categories: ['File'],
		hideFromProduction: true,
	},
	{
		tag: 'fileType.refinance',
		categories: ['File'],
		hideFromProduction: true,
	},
	{
		tag: 'fileType.sale',
		categories: ['File'],
		hideFromProduction: true,
	},
	{
		tag: 'fileType',
		categories: ['File'],
	},
	{
		tag: 'conveyancingFee.amount',
		categories: ['Financial', 'Account', 'Conveyancing Fee'],
	},
	{
		tag: 'conveyancingFee.formatted',
		categories: ['Financial', 'Account', 'Conveyancing Fee'],
		hideFromProduction: true,
	},
	{
		tag: 'conveyancingFee.text',
		categories: ['Financial', 'Account', 'Conveyancing Fee'],
	},
	{
		tag: 'conveyancingFee',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.tax.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.tax.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.tax.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.tax',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.tax.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.refund.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.refund.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.refund.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.refund',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.refund.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.netAmount.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.netAmount.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.netAmount.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.netAmount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.provincial.netAmount.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.netAmount.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.netAmount.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.netAmount.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.netAmount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.netAmount.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.tax.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.tax.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.tax.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.tax',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.tax.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.refund.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.refund.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.refund.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.refund',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.refund.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.adminFee.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.adminFee.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.adminFee.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.adminFee',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.municipal.adminFee.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.total.netAmount.amount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.total.netAmount.formatted',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.total.netAmount.text',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.total.netAmount',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.total.netAmount.number',
		categories: ['Financial', 'Account', 'LTT'],
	},
	{
		tag: 'ltt.direction.trustLedger',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
		description:
			' A TRUE or FALSE output depending on if the LTT is sent to display on the Trust Ledger.',
	},
	{
		tag: 'ltt.direction.statementOfAccount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
		description:
			'A TRUE or FALSE output depending on if the LTT is sent to display on the Statement of Account.',
	},
	{
		tag: 'ltt.direction.hidden',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
		description:
			'A TRUE or FALSE output depending on if the LTT is set to be hidden from the Trust Ledger and the Statement of Account.',
	},
	{
		tag: 'ltt.assumedMortgages.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.assumedMortgages.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.assumedMortgages.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.assumedMortgages',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.moniesPaid.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.moniesPaid.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.moniesPaid.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.moniesPaid',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.mortgagesBackToVendor.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.mortgagesBackToVendor.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.mortgagesBackToVendor.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.mortgagesBackToVendor',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.otherConsiderations.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.otherConsiderations.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.otherConsiderations.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.otherConsiderations',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.propertyTransferred.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.propertyTransferred.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.propertyTransferred.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.propertyTransferred',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.chattels.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.chattels.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.chattels.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.chattels',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.otherConsiderations.tax.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.otherConsiderations.tax.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.otherConsiderations.tax.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.otherConsiderations.tax',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.sum.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.sum.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.sum.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.sum',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.total.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.total.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.total.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.subjectTo.total',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.totalConsiderations',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.totalConsiderations.amount',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.totalConsiderations.formatted',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'ltt.totalConsiderations.text',
		categories: ['Financial', 'Account', 'LTT'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgageDischargeFee.amount',
		categories: ['Financial', 'Account', 'Mortgage Dis'],
	},
	{
		tag: 'mortgageDischargeFee.formatted',
		categories: ['Financial', 'Account', 'Mortgage Dis'],
		hideFromProduction: true,
	},
	{
		tag: 'mortgageDischargeFee.text',
		categories: ['Financial', 'Account', 'Mortgage Dis'],
	},
	{
		tag: 'mortgageDischargeFee',
		categories: ['Financial', 'Account', 'Mortgage Dis'],
	},
	{
		tag: 'statementOfAccounts.balanceOwing.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.balanceOwing.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.balanceOwing.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.balanceOwing',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFee.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFee.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFee.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFee',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFeeWithHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFeeWithHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFeeWithHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.conveyancingFeeWithHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.feeAndDisbursements.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.feeAndDisbursements.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.feeAndDisbursements.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.feeAndDisbursements',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.grandTotal.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.grandTotal.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.grandTotal.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.grandTotal',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.receivedOnAccount.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.receivedOnAccount.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.receivedOnAccount.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.receivedOnAccount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.table',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.tableCondensed',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursements.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursements.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursements.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursements',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursementsWithHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursementsWithHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursementsWithHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalDisbursementsWithHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFees.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFees.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFees.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFees',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFeesWithHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFeesWithHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFeesWithHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccounts.totalFeesWithHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsBalanceOwing.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsBalanceOwing.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsBalanceOwing.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsBalanceOwing',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFee.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFee.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFee.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFee',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFeeWithHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFeeWithHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFeeWithHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsConveyancingFeeWithHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsFeesAndDisbursements.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsFeesAndDisbursements.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsFeesAndDisbursements.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsFeesAndDisbursements',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsGrandTotal.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsGrandTotal.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsGrandTotal.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsGrandTotal',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsReceivedOnAccount.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsReceivedOnAccount.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsReceivedOnAccount.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsReceivedOnAccount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTable',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTableCondensed',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursements.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursements.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursements.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursements',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursementsWithHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursementsWithHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursementsWithHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalDisbursementsWithHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFees.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFees.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFees.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFees',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFeesWithHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFeesWithHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFeesWithHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAccountsTotalFeesWithHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAdjustment.report',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAdjustment.table',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAdjustmentsReport',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'statementOfAdjustmentsTable',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'totalHST.amount',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'totalHST.formatted',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'totalHST.text',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'totalHST',
		categories: ['Financial', 'Account'],
	},
	{
		tag: 'adjustmentDate',
		categories: ['Financial', 'Adjustments'],
		fileType: PurchaseSale,
	},
	{
		tag: 'adjustments.commonExpensesTotal.amount',
		categories: ['Financial', 'Adjustments'],
		fileType: PurchaseSale,
	},
	{
		tag: 'adjustments.commonExpensesTotal.formatted',
		categories: ['Financial', 'Adjustments'],
		fileType: PurchaseSale,
	},
	{
		tag: 'adjustments.commonExpensesTotal.text',
		categories: ['Financial', 'Adjustments'],
		fileType: PurchaseSale,
	},
	{
		tag: 'adjustments.commonExpensesTotal',
		categories: ['Financial', 'Adjustments'],
		fileType: PurchaseSale,
	},
	{
		tag: 'balanceDue.amount',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.calculated.amount',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.calculated.formatted',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.calculated.text',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.calculated',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.formatted',
		categories: ['Financial', 'Adjustments'],
		hideFromProduction: true,
	},
	{
		tag: 'balanceDue.overridden.amount',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.overridden.formatted',
		categories: ['Financial', 'Adjustments'],
		hideFromProduction: true,
	},
	{
		tag: 'balanceDue.overridden.text',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.overridden',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.lessDeductions.amount',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.lessDeductions.formatted',
		categories: ['Financial', 'Adjustments'],
		hideFromProduction: true,
	},
	{
		tag: 'balanceDue.lessDeductions.text',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.lessDeductions',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.totalDeductions.amount',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.totalDeductions.formatted',
		categories: ['Financial', 'Adjustments'],
		hideFromProduction: true,
	},
	{
		tag: 'balanceDue.totalDeductions.text',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.totalDeductions',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.deductionsType',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balanceDue.text',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'x',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'balancePayableTo',
		categories: ['Financial', 'Adjustments'],
	},
	{
		tag: 'amountInTrust.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'amountInTrust.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'amountInTrust.redirected.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'amountInTrust.redirected.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'amountInTrust.redirected.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'amountInTrust.redirected',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'amountInTrust.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'amountInTrust',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalPayments.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalPayments.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'ledger.totalPayments.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalPayments',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalReceipts.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalReceipts.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'ledger.totalReceipts.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalReceipts',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalsDifference.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalsDifference.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'ledger.totalsDifference.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalsDifference',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'ledger.totalsMatch',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'receiveFromClient.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'receiveFromClient.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'receiveFromClient.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'receiveFromClient',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedger.cashShortfall.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedger.cashShortfall.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'trustLedger.cashShortfall.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedger.cashShortfall',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedgerPaymentsTableCondensed',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedgerReceiptsTableCondensed',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedgerTable',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'trustLedgerTableCondensed',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'overriddenBalanceDueOnClosing.amount',
		categories: ['Financial', 'Trust'],
		description: 'added in Statement of Adjustment, displays in Trust',
		fileType: PurchaseSale,
	},
	{
		tag: 'overriddenBalanceDueOnClosing.formatted',
		categories: ['Financial'],
		hideFromProduction: true,
	},
	{
		tag: 'overriddenBalanceDueOnClosing.text',
		categories: ['Financial'],
	},
	{
		tag: 'overriddenBalanceDueOnClosing',
		categories: ['Financial'],
	},
	{
		tag: 'paidToClient.amount',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'paidToClient.formatted',
		categories: ['Financial', 'Trust'],
		hideFromProduction: true,
	},
	{
		tag: 'paidToClient.text',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'paidToClient',
		categories: ['Financial', 'Trust'],
	},
	{
		tag: 'fireInsurance.brokerage.address.block',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.city',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.country',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.faxNumber',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.line.condensed',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.line',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.name',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.phoneNumber',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.poBox',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.postcode',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.province.long',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.province',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.street',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.street2',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.unit',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address.website',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.address',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.addressBlock',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.addressLine',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.brokerage.name',
		categories: ['Fire Insurance', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.block',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.city',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.country',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.faxNumber',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.line.condensed',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.line',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.name',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.phoneNumber',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.poBox',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.postcode',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.province.long',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.province',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.street',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.street2',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.unit',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address.website',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.address',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.addressBlock',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.addressLine',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.faxNumber',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.name',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.company.phoneNumber',
		categories: ['Fire Insurance', 'Company'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.coverage.amount',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.coverage.formatted',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'fireInsurance.coverage.text',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.coverage',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.expiryDate',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.type.binder',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'fireInsurance.type.policy',
		categories: ['Fire Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'business.address.block',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.cellPhone',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.city',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.country',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.email',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.faxNumber',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.line.condensed',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.line',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.name',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.officeName',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.phoneNumber',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.poBox',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.postcode',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.primary',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.province.long',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.province',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.street',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.street2',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.unit',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address.website',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.address',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.addressBlock',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.addressLine',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.name',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'business.hstRegistrationNumber',
		categories: ['Firm-Related', 'Business'],
	},
	{
		tag: 'clerk.email',
		categories: ['Firm-Related', 'Clerk'],
	},
	{
		tag: 'clerk.faxNumber',
		categories: ['Firm-Related', 'Clerk'],
	},
	{
		tag: 'clerk.initials',
		categories: ['Firm-Related', 'Clerk'],
	},
	{
		tag: 'clerk.name',
		categories: ['Firm-Related', 'Clerk'],
	},
	{
		tag: 'clerk.phoneExt',
		categories: ['Firm-Related', 'Clerk'],
	},
	{
		tag: 'clerk.phoneNumber',
		categories: ['Firm-Related', 'Clerk'],
	},
	{
		tag: 'lawyer.email',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'signatureLine.lawyer',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'signatureBlock.lawyer',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'lawyer.faxNumber',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'lawyer.initials',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'lawyer.name',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'lawyer.phoneExt',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'lawyer.phoneNumber',
		categories: ['Firm-Related', 'Lawyer'],
	},
	{
		tag: 'yoursTruly.lawyer',
		categories: ['Firm-Related', 'Lawyer'],
		description:
			'The Complimentary close for your Letter documents, as per the Business Defaults setting.\nAvailable for Sale, Purchase, and Refinance',
	},
	{
		tag: 'office.address.block',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.cellPhone',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.city',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.country',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.email',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.faxNumber',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.line.condensed',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.line',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.name',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.officeName',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.phoneNumber',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.poBox',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.postcode',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.primary',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.province.long',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.province',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.street',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.street2',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.unit',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address.website',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.address',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.addressBlock',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.addressLine',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.name',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.hstRegistrationNumber',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'office.useSingularBarristerSolicitor',
		categories: ['Firm-Related', 'Office'],
	},
	{
		tag: 'complianceRequests.all.id.fee.amount',
		categories: ['Jurisdiction'],
		hideFromProduction: true,
	},
	{
		tag: 'complianceRequests.all.id.fee.formatted',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'complianceRequests.all.id.fee.text',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'complianceRequests.all.id.fee',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'complianceRequests.all.id.id',
		categories: ['Jurisdiction'],
		hideFromProduction: true,
	},
	{
		tag: 'complianceRequests.length',
		categories: ['Jurisdiction'],
		hideFromProduction: true,
	},
	{
		tag: 'jurisdictions.id.departments.id.addressBlock',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.departments.id.attentionBlock',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.any',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.building',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.conservation',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.fire',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.hydro',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.tax',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.water',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.zoning',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.departments.utilities',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.buildingDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.conservationDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.fireDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.hydroDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.taxDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.waterDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.zoningDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.utilitiesDepartments',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.departments.id.faxNumber',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.departments.id.name',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.departments.id.type',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.name',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.id.primary',
		categories: ['Jurisdiction'],
		hideFromProduction: true,
	},
	{
		tag: 'jurisdictions.length',
		categories: ['Jurisdiction'],
		hideFromProduction: true,
	},
	{
		tag: 'jurisdictions.primary.departments.id.addressBlock',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.primary.departments.id.attentionBlock',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.primary.departments.id.faxNumber',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.primary.departments.id.name',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.primary.departments.id.type',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.primary.name',
		categories: ['Jurisdiction'],
	},
	{
		tag: 'jurisdictions.primary.primary',
		categories: ['Jurisdiction'],
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.assignmentOfRents.registrationDate',
		categories: ['Mortgages New', 'Assignment of Rents'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.assignmentOfRents.registrationNumber',
		categories: ['Mortgages New', 'Assignment of Rents'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.assignmentOfRents',
		categories: ['Mortgages New', 'Assignment of Rents'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.cellNumber',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.email',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.faxNumber',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.fees.amount',
		categories: ['Mortgages New', 'Broker'],
		description:
			'use with IFF logic - number only - no comma, period or dollar sign',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.broker.fees.formatted',
		categories: ['Mortgages New', 'Broker'],
		description: 'example:  $7,000.65 USE IN FILTER LOGIC',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.broker.fees.text',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.fees',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.name',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.phoneNumber',
		categories: ['Mortgages New', 'Broker'],
		description: 'Broker cell phone number',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.broker.workNumber',
		categories: ['Mortgages New', 'Broker'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.block',
		categories: ['Mortgages New', 'Brokerage'],
		description: 'Address block with postal code alone on last line ',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.city',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.country',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.faxNumber',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.line.condensed',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.line',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.name',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.phoneNumber',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.poBox',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.postcode',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.province.long',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.province',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.street',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.street2',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.unit',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address.website',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.address',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.addressBlock',
		categories: ['Mortgages New', 'Brokerage'],
		description: 'Address block with postal code alone on last line ',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.addressLine',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.email',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.faxNumber',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.name',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.brokerage.phoneNumber',
		categories: ['Mortgages New', 'Brokerage'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.block',
		categories: ['Mortgages New', 'Correspondence'],
		description: "Law Firm's address block who is representing the Lender.",
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.city',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.country',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.faxNumber',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.line.condensed',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.line',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.name',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.phoneNumber',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.poBox',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.postcode',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.province.long',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.province',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.street',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.street2',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.unit',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address.website',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.address',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.addressBlock',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.addressLine',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.email',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.faxNumber',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.name',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.phoneNumber',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawfirm.website',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawyer.email',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawyer.firstName',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawyer.lastName',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawyer.name',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lawyer.phoneNumber',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondenceType.solicitor',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondence.lenderRELine',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.correspondenceType.mortgagee',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.lenders.count',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.lenders.signatureBlock',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.lenders.signatureLine',
		categories: ['Mortgages New', 'Correspondence'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.first.maturityDate',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
		description: 'Deprecated - use balanceDueDate instead',
	},
	{
		tag: 'mortgages.first.maturityDateAsReg',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
		description: 'Deprecated - use balanceDueDate instead',
	},
	{
		tag: 'mortgages.first.netAdvance',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.netAdvance.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.netAdvance.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.netAdvance.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.principalAmount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.principalAmount.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.principalAmount.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.principalAmount.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.priority',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.priority.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.priority.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.registrationDate',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPayments',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPayments.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPayments.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPayments.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPaymentsAsReg',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPaymentsAsReg.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPaymentsAsReg.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.regularPaymentsAsReg.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.reLine',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.sctNumber',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.signatureBlock',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.signatureLine',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.signingDate',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.other',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.other.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.other.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.other.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.paymentAmount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.paymentAmount.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.paymentAmount.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.paymentAmount.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.taxAmount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.taxAmount.amount',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.taxAmount.formatted',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.taxes.taxAmount.text',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.first.transactionType',
		categories: ['Mortgages New', 'First mortgage'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.generalSecurityAgreement.registrationDate',
		categories: ['Mortgages New', 'General Security Agreement'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.generalSecurityAgreement.registrationNumber',
		categories: ['Mortgages New', 'General Security Agreement'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.generalSecurityAgreement',
		categories: ['Mortgages New', 'General Security Agreement'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.count',
		categories: ['Mortgages New', 'Guarantors'],
		description: 'displays a number eg 1',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.length',
		categories: ['Mortgages New', 'Guarantors'],
		description: 'same as .count, but no longer used.',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.guarantors.names',
		categories: ['Mortgages New', 'Guarantors'],
		description:
			"names separated by commas, with 'and' before the last name * I think we need to get rid of the last comma eg, Jim Smith, Mike Green, and Philip Anders",
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.amAre',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.hasHave',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.heSheThey',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.himHerThem',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureBlock.guarantors',
		categories: ['Mortgages New', 'Guarantors'],
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.himselfHerselfThemselves',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureLine.guarantors',
		categories: ['Mortgages New', 'Guarantors'],
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.hisHersTheirs',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.hisHerTheir',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.isAre',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.IWe',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.meUs',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.mineOurs',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.myOur',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.pronouns.wasWere',
		categories: ['Mortgages New', 'Guarantors'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.signatureBlock',
		categories: ['Mortgages New', 'Guarantors'],
		description:
			'signature line with name beneath - line is right aligned on page, with name being left aligned with the line',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.guarantors.signatureLine',
		categories: ['Mortgages New', 'Guarantors'],
		description:
			'line goes right across page (or cell if in table) with name left aligned',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureLine.mortgagees',
		categories: ['Mortgages New'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureLine.mortgagors',
		categories: ['Mortgages New'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureBlock.mortgagees',
		categories: ['Mortgages New'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'signatureBlock.mortgagors',
		categories: ['Mortgages New'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.id',
		categories: ['Mortgages New'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.institution.address.block',
		categories: ['Mortgages New', 'Lender'],
		description:
			'address in envelope format, but NOT Canada Post standards - postal code on new line below city, province',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.city',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.country',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.faxNumber',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.line.condensed',
		categories: ['Mortgages New', 'Lender'],
		description: 'address on one line excluding province and postal code',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.line',
		categories: ['Mortgages New', 'Lender'],
		description: 'address on one line INCLUDING province and postal code',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.name',
		categories: ['Mortgages New', 'Lender'],
		description: 'name of lender eg Bank of Montreal',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.institution.address.phoneNumber',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.poBox',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.postcode',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.province.long',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.province',
		categories: ['Mortgages New', 'Lender'],
		description: 'Province short eg ON, BC',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.street',
		categories: ['Mortgages New', 'Lender'],
		description:
			'pulls in street only, but for BMO, the first part of the street is Mortgage Service Centre, so that what is produced',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.street2',
		categories: ['Mortgages New', 'Lender'],
		description: 'info entered into street 2',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.unit',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address.website',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.address',
		categories: ['Mortgages New', 'Lender'],
		description: 'address on one line, no province or postal code',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.addressBlock',
		categories: ['Mortgages New', 'Lender'],
		description:
			'envelope style, but postal code on a separate line beneath city, province',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.addressLine',
		categories: ['Mortgages New', 'Lender'],
		description: 'full address on one line',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.bank',
		categories: ['Mortgages New', 'Lender'],
		description: 'name of lender',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.email',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.fax',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.name',
		categories: ['Mortgages New', 'Lender'],
		description: 'name of lender',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.institution.phone',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.reLine',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.clauses',
		categories: ['Mortgages New', 'Lender'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestCalculated',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.commitmentDate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.insuranceAmount',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.adjustmentDate.asReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.adjustmentDate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.calculated.asReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.calculated',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.onlyPayments',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.interest.rate.asReg',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'shows  3% per annum for fixed, variable would just show 3%',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.rate.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'just shows percent eg 3%',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.interest.rate.type.asReg',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'variable shows + / - 2%',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.rate.type',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'fixed / variable',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.rate.value',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'number only eg   2',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interest.rate',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'variable:  prime +',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestAdjustmentDate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestAdjustmentDateAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestRate.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestRate.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.interestRate.value',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestRate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestRateAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestRateType',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.interestRateTypeAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.loanNumber',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.maturityDate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		description: 'Deprecated - use balanceDueDate instead',
	},
	{
		tag: 'mortgages.id.maturityDateAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		description: 'Deprecated - use balanceDueDate instead',
	},
	{
		tag: 'mortgages.id.netAdvance.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.netAdvance.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.netAdvance.text',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.netAdvance',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.paymentDue',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.paymentDueAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.paymentFrequency',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.paymentFrequencyAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.principalAmount.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		description:
			'amount with no dollar sign, commas, periods ie $10.033 would show 10033',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.principalAmount.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.principalAmount.text',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.principalAmount',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.priority.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.priority.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.priority',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'Associated Mortage priority',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.registrationDate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.registrationNumber',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.regularPayments.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.regularPayments.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.regularPayments.text',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.regularPayments',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.regularPaymentsAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.sctNumber',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.signatureBlock',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.signatureLine',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.signingDate',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.term',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.transactionType',
		categories: ['Mortgages New', 'Mortgage details'],
		description:
			'This will let us know what type of Mortgage the mortgage is, whether it is arranged or a bridge loan.',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.titleInsurance.lenderPolicy.insuredAmount.amount',
		categories: [
			'Mortgages New',
			'Mortgage details',
			'Title Insurance',
			'Lender Policy',
		],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.titleInsurance.lenderPolicy.insuredAmount.text',
		categories: [
			'Mortgages New',
			'Mortgage details',
			'Title Insurance',
			'Lender Policy',
		],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.titleInsurance.lenderPolicy.insuredAmount.formatted',
		categories: [
			'Mortgages New',
			'Mortgage details',
			'Title Insurance',
			'Lender Policy',
		],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.titleInsurance.lenderPolicy.policyNumber',
		categories: [
			'Mortgages New',
			'Mortgage details',
			'Title Insurance',
			'Lender Policy',
		],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.length',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'tells you how many mortgages there are - use with If logic',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.count',
		categories: ['Mortgages New', 'Mortgage details'],
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.amortization',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.amount.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'principal amount, no cents, no dollar sign, no comma',
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.amount.formatted',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'mortgages.id.amount.text',
		categories: ['Mortgages New', 'Mortgage details'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.amount',
		categories: ['Mortgages New', 'Mortgage details'],
		description: 'principal amount, includes $ , .',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.firstDate',
		categories: ['Mortgages New', 'Mortgage details'],
		description:
			'The First Payment Date in the Actual Column wihin the Mortgage Tab.',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'mortgages.id.firstDateAsReg',
		categories: ['Mortgages New', 'Mortgage details'],
		description:
			'The First Payment Date in the As Regsitered Column wihin the Mortgage Tab.',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'otherParty.brokerage.address.block',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.city',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.country',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.faxNumber',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.line.condensed',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.line',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.name',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.phoneNumber',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.poBox',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.postcode',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.province.long',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.province',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.street',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.street2',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.unit',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address.website',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.address',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.addressBlock',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.addressLine',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.brokerage.broker.name',
		categories: ['Other Party', 'Brokerage'],
		fileType: PurchaseSale,
	},
	{
		tag: 'otherParty.count',
		categories: ['Other Party'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.estate',
		categories: ['Other Party'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.lawfirm.address.block',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.city',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.country',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.faxNumber',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.line.condensed',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.line',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.name',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.phoneNumber',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.poBox',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.postcode',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.province.long',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.province',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.street',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.street2',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.unit',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address.website',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.address',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.addressBlock',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.addressLine',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.email',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.fax',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.firstName',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.gender',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.initials',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.lastName',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.name',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.phoneNumber',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.title',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.clerk.workPhone',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.email',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.faxNumber',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.email',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.fax',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.firstName',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'signatureLine.otherPartyLawyer',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.initials',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.lastName',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.name',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.phoneNumber',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.lawyer.workPhone',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'signatureBlock.otherPartyLawyer',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.name',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.phoneNumber',
		categories: ['Other Party', 'Law Firm'],
	},
	{
		tag: 'otherParty.lawfirm.website',
		categories: ['Other Party', 'Law Firm'],
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.powerOfAttorney',
		categories: ['Other Party', 'Law Firm'],
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.associatedNames',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.associatedNamesTitles',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.capacityOfOwnership.name',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.capacityOfOwnership.type.capacityPerClient',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.capacityOfOwnership.type.jointTenants',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.capacityOfOwnership.type.registeredOwner',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.capacityOfOwnership.type.silent',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.capacityOfOwnership.type.tenantsInCommon',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.count',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.lastNames',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.names',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.namesTitles',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.amAre',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.hasHave',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.heSheThey',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.himHerThem',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.himselfHerselfThemselves',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.hisHersTheirs',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.hisHerTheir',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.isAre',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.IWe',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.meUs',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.mineOurs',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.myOur',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.pronouns.wasWere',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
	},
	{
		tag: 'otherParty.purchasers.type.builder',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.type.corporation',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.type.person',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.purchasers.unique.length',
		categories: ['Other Party', 'Purchaser'],
		fileType: Sale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.type.builder',
		categories: ['Other Party'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.type.corporation',
		categories: ['Other Party'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.type.person',
		categories: ['Other Party'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.vendors.associatedNames',
		categories: ['Other Party', 'Vendor', 'Associated'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.associatedNamesTitles',
		categories: ['Other Party', 'Vendor', 'Associated'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.count',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.vendors.lastNames',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.names',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.namesTitles',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.amAre',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.hasHave',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.heSheThey',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.himHerThem',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.himselfHerselfThemselves',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.hisHersTheirs',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.hisHerTheir',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.isAre',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.IWe',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.meUs',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.mineOurs',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.myOur',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.pronouns.wasWere',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
	},
	{
		tag: 'otherParty.vendors.type.builder',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.vendors.type.corporation',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.vendors.type.person',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
		hideFromProduction: true,
	},
	{
		tag: 'otherParty.vendors.unique.length',
		categories: ['Other Party', 'Vendor'],
		fileType: Purchase,
		hideFromProduction: true,
	},
	{
		tag: 'property.address.block',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.city',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.country',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.faxNumber',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.line.condensed',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.line',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.name',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.phoneNumber',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.poBox',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.postcode',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.province.long',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.province',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.street',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.street2',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.unit',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address.website',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.address',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.addressBlock',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.addressLine',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.addressMunicipal',
		categories: ['Property', 'Address'],
	},
	{
		tag: 'property.registration.registrationMethod',
		categories: ['Property', 'Registration'],
	},
	{
		tag: 'property.registration.landTitles',
		categories: ['Property', 'Registration'],
	},
	{
		tag: 'property.registration.registry',
		categories: ['Property', 'Registration'],
	},
	{
		tag: 'transferRegistrationNumber',
		categories: ['Property', 'Property Registration'],
	},
	{
		tag: 'property.condo.attention',
		categories: ['Property', 'Condo'],
	},
	{
		tag: 'property.condo.baseFee.amount',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.baseFee.formatted',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.baseFee.text',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.baseFee',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.corporation.address.block',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.city',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.country',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.faxNumber',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.line.condensed',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.line',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.name',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.phoneNumber',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.poBox',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.postcode',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.province.long',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.province',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.street',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.street2',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.unit',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address.website',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.address',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.addressBlock',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.addressLine',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.email',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.fax',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.phone',
		categories: ['Property', 'Condo', 'Condo Corporation'],
	},
	{
		tag: 'property.condo.corporation.selfManaged',
		categories: ['Property', 'Condo', 'Condo Corporation'],
		hideFromProduction: true,
	},
	{
		tag: 'property.condo.management.address.block',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.city',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.country',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.faxNumber',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.line.condensed',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.line',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.name',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.phoneNumber',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.poBox',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.postcode',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.province.long',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.province',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.street',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.street2',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.unit',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address.website',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.address',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.addressBlock',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.addressLine',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.email',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.fax',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.management.phone',
		categories: ['Property', 'Condo', 'Condo Management'],
	},
	{
		tag: 'property.condo.totalFees.amount',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.totalFees.formatted',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.totalFees.text',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.totalFees',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.urgencyFee.amount',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.urgencyFee.formatted',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.urgencyFee.text',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condo.urgencyFee',
		categories: ['Property', 'Condo', 'Condo Fees'],
	},
	{
		tag: 'property.condoPins',
		categories: ['Property', 'Condo'],
	},
	{
		tag: 'property.condoPlanNumbers',
		categories: ['Property', 'Condo'],
	},
	{
		tag: 'property.condoUnitNames',
		categories: ['Property', 'Condo'],
	},
	{
		tag: 'property.commonExpenses.dueDate',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.dueDateLong',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.primaryUnit.amount',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.primaryUnit.formatted',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.primaryUnit.text',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.primaryUnit',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.total.amount',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.total.formatted',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.total.text',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.total',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.commonExpenses.total',
		categories: ['Property', 'Condo', 'Common Expenses'],
	},
	{
		tag: 'property.multiUnit.unitType',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.multiUnit.numberOfUnits',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.condoUnits.id.commonExpenses',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.custom',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.easement',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.feeSimple',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.feeSimpleEasement',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.feeSimpleMiningRights',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.feeSimpleSurfaceRights',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.leasehold',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.lifeEstate',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.name',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.interestType.other',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.jurisdiction',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.legalDescription.all',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.legalDescription.primary',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.legalDescription.condensed',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.lro',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.name',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.number',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.block',
		categories: ['Property', 'Land Registry Office'],
		description: 'Land Registered Office',
	},
	{
		tag: 'property.lro.selected.address.city',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.country',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.faxNumber',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.line.condensed',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.line',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.name',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.phoneNumber',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.poBox',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.postcode',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.province.long',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.province',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.street',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.street2',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.unit',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address.website',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.address',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.addressBlock',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.addressLine',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		tag: 'property.lro.selected.name',
		categories: ['Property', 'Land Registry Office'],
	},
	{
		description: 'Loan to value %',
		categories: ['Property', 'Loan to Value'],
		tag: 'property.loanToValue',
		fileType: PurchaseRefinance,
	},
	{
		description: 'Loan to Value %',
		categories: ['Property', 'Loan to Value'],
		tag: 'property.loanToValue.percentage',
		fileType: PurchaseRefinance,
	},
	{
		description: 'Loan to value - source of property value',
		categories: ['Property', 'Loan to Value'],
		tag: 'property.loanToValue.source',
		fileType: PurchaseRefinance,
	},
	{
		description: 'Loan to value - mortgage total',
		categories: ['Property', 'Loan to Value'],
		tag: 'property.loanToValue.mortgageTotal',
		fileType: PurchaseRefinance,
	},
	{
		tag: 'property.ownerResidesAtProperty',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.commonExpenses',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.id',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.latestInstrument',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.legalDescription.overridden',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.legalDescription.teranet',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.levelNumber',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.multiUnit.unitType',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.unitNumber',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.parcels.id.unitType',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.primaryParcel.legalDescription',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.primaryParcel.pin',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.surveyDate',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.surveyLongDate',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.titlePins',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.building',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.condition.new',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.condition.resale',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.condition',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.condo',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.farmland',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.home',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.mobileHome',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.other',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.parcelOfTiedLand',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.tenanted',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.usage.commercial',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.usage.residential',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.usage',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type.vacant',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.type',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.vacantTax',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.value.amount',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.value.formatted',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.value.text',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'property.value',
		categories: ['Property', 'Property Details'],
	},
	{
		tag: 'purchasers.associatedNames',
		categories: ['Purchaser', 'Associated'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.associatedNamesTitles',
		categories: ['Purchaser', 'Associated'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.capacityOfOwnership.name',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.capacityOfOwnership.type.capacityPerClient',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.capacityOfOwnership.type.jointTenants',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'borrowers.associatedNames',
		categories: ['Borrower', 'Associated'],
	},
	{
		tag: 'borrowers.associatedNamesTitles',
		categories: ['Borrower', 'Associated'],
	},
	{
		tag: 'borrowers.capacityOfOwnership.name',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.capacityOfOwnership.type.capacityPerClient',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.capacityOfOwnership.type.jointTenants',
		categories: ['Borrower'],
	},
	{
		tag: 'signatureLine.purchaserLawyer',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureLine.purchasers',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureLine.purchasersNoTitle',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.capacityOfOwnership.type.registeredOwner',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.capacityOfOwnership.type.silent',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.capacityOfOwnership.type.tenantsInCommon',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.count',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'borrowers.capacityOfOwnership.type.registeredOwner',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.capacityOfOwnership.type.silent',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.capacityOfOwnership.type.tenantsInCommon',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.count',
		categories: ['Borrower'],
	},
	{
		tag: 'signatureBlock.purchaserLawyer',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.purchasers',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.purchasersNoTitle',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.purchasersWithWitnesses',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.lastNames',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.names',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.namesTitles',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'purchasers.unique.count',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'borrowers.lastNames',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.names',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.namesTitles',
		categories: ['Borrower'],
	},
	{
		tag: 'borrowers.unique.count',
		categories: ['Borrower'],
	},
	{
		tag: 'rollNumbers.primary',
		categories: ['Purchaser'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.balanceOwing.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.balanceOwing.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.balanceOwing.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.balanceOwing',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.grandTotal.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.grandTotal.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.grandTotal.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.grandTotal',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.hstAmount.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.hstAmount.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.hstAmount.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.hstAmount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.payable.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.payable.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.payable.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.payable',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.percentage.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.percentage.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.percentage.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.percentage',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'excessDeposit.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'excessDeposit.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'excessDeposit.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'excessDeposit',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.balanceOwing.amount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.balanceOwing.formatted',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.balanceOwing.text',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.balanceOwing',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.grandTotal.amount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.grandTotal.formatted',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.grandTotal.text',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.grandTotal',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.hstAmount.amount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.hstAmount.formatted',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.hstAmount.text',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.hstAmount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.payable.amount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.payable.formatted',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.payable.text',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.payable',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.percentage.amount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.percentage.formatted',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.percentage.text',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.percentage',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.excessDeposit.formatted',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.excessDeposit.amount',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.excessDeposit.text',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.sellerBrokerage.excessDeposit',
		categories: ['Real Estate Broker', 'Seller Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.balanceOwing.amount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.balanceOwing.formatted',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.balanceOwing.text',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.balanceOwing',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.grandTotal.amount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.grandTotal.formatted',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.grandTotal.text',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.grandTotal',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.hstAmount.amount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.hstAmount.formatted',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.hstAmount.text',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.hstAmount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.payable.amount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.payable.formatted',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.payable.text',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.payable',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.percentage.amount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.percentage.formatted',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.percentage.text',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.percentage',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.excessDeposit.formatted',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.excessDeposit.amount',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.excessDeposit.text',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.buyerBrokerage.excessDeposit',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.balanceOwing.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.balanceOwing.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.balanceOwing.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.balanceOwing',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.grandTotal.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.grandTotal.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.grandTotal.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.grandTotal',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.hstAmount.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.hstAmount.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.hstAmount.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.hstAmount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.payable.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.payable.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.payable.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.payable',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.percentage.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.percentage.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.percentage.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.percentage',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.excessDeposit.formatted',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.excessDeposit.amount',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.excessDeposit.text',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.clientBrokerage.excessDeposit',
		categories: ['Real Estate Broker', 'Client Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.balanceOwing.amount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.balanceOwing.formatted',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.balanceOwing.text',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.balanceOwing',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.grandTotal.amount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.grandTotal.formatted',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.grandTotal.text',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.grandTotal',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.hstAmount.amount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.hstAmount.formatted',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.hstAmount.text',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.hstAmount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.payable.amount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.payable.formatted',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.payable.text',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.payable',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.percentage.amount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.percentage.formatted',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.percentage.text',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.percentage',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.excessDeposit.formatted',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.excessDeposit.amount',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.excessDeposit.text',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'commission.otherPartyBrokerage.excessDeposit',
		categories: ['Real Estate Broker', 'Other Party Broker', 'Commission'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.block',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.city',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.country',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.faxNumber',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.line.condensed',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.line',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.name',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.phoneNumber',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.poBox',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.postcode',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.province.long',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.province',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.street',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.street2',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.unit',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address.website',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.address',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.addressBlock',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.addressLine',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.broker.email',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.broker.firstName',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.broker.gender',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.broker.lastName',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.broker.name',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.broker.phoneNumber',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.email',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.faxNumber',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.name',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.phoneNumber',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'clientBrokerage.website',
		categories: ['Real Estate Broker', 'Client Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.block',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.city',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.country',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.faxNumber',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.line.condensed',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.line',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.name',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.phoneNumber',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.poBox',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.postcode',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.province.long',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.province',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.street',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.street2',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.unit',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address.website',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.address',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.addressBlock',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.addressLine',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.broker.email',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.broker.firstName',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.broker.gender',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.broker.lastName',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.broker.name',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.broker.phoneNumber',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.email',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.faxNumber',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.name',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.phoneNumber',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.website',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'sellerBrokerage.fileNumber',
		categories: ['Real Estate Broker', 'Seller Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.block',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.city',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.country',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.faxNumber',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.line.condensed',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.line',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.name',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.phoneNumber',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.poBox',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.postcode',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.province.long',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.province',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.street',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.street2',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.unit',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address.website',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.address',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.addressBlock',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.addressLine',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.broker.email',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.broker.firstName',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.broker.gender',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.broker.lastName',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.broker.name',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.broker.phoneNumber',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.email',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.faxNumber',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.name',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.phoneNumber',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.website',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'buyerBrokerage.fileNumber',
		categories: ['Real Estate Broker', 'Buyer Broker', 'Contact Info'],
		fileType: PurchaseSale,
	},
	{
		tag: 'requisitionDate',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'requisitionInstrumentList',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'requisitionLetterDate',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'requisitionLetterLongDate',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'requisitionLongDate',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'requisitionReceivedOnTime',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'requisitions.length',
		categories: ['Requisitions'],
		fileType: Purchase,
	},
	{
		tag: 'titleInsurance',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.company',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.counselCredit.amount',
		categories: ['Title Insurance', 'lender policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.counselCredit.formatted',
		categories: ['Title Insurance', 'lender policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.counselCredit.text',
		categories: ['Title Insurance', 'lender policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.counselCredit',
		categories: ['Title Insurance', 'lender policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.effectiveDate',
		categories: ['Title Insurance', 'lender policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.ownerPolicy.insuredAmount.amount',
		categories: ['Title Insurance', 'owner policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.ownerPolicy.insuredAmount.formatted',
		categories: ['Title Insurance', 'owner policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.ownerPolicy.insuredAmount.text',
		categories: ['Title Insurance', 'owner policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.ownerPolicy.insuredAmount',
		categories: ['Title Insurance', 'owner policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.ownerPolicy.name',
		categories: ['Title Insurance', 'owner policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.ownerPolicy.policyNumber',
		categories: ['Title Insurance', 'owner policy'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.premium.amount',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.premium.formatted',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.premium.text',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.premium',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.total.amount',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.total.formatted',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.total.text',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'titleInsurance.total',
		categories: ['Title Insurance'],
		fileType: PurchaseRefinance,
	},
	{
		tag: 'undertakings.all.id.followUp',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'undertakings.all.id.fulfilled',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'undertakings.all.id.id',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'undertakings.all.id.subject',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'undertakings.all.id.text',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'undertakings.all.id.type',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'undertakings.length',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
		hideFromProduction: true,
	},
	{
		tag: 'undertakingsList',
		categories: ['Undertakings'],
		fileType: SaleRefinance,
	},
	{
		tag: 'vendors.associatedNames',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'vendors.associatedNamesTitles',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureLine.vendorLawyer',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureLine.offerors',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.vendorLawyer',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.vendors',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.vendorsNoTitle',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.vendorsWithWitnesses',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureBlock.offerors',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureLine.vendors',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'signatureLine.vendorsNoTitle',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'vendors.capacityOfOwnership.type.capacityPerClient',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'vendors.capacityOfOwnership.type.jointTenants',
		categories: ['Vendor'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'vendors.capacityOfOwnership.type.registeredOwner',
		categories: ['Vendor'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'vendors.capacityOfOwnership.type.silent',
		categories: ['Vendor'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'vendors.capacityOfOwnership.type.tenantsInCommon',
		categories: ['Vendor'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'vendors.count',
		categories: ['Vendor'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'vendors.lastNames',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'vendors.names',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'vendors.namesTitles',
		categories: ['Vendor'],
		fileType: PurchaseSale,
	},
	{
		tag: 'vendors.unique.count',
		categories: ['Vendor'],
		fileType: PurchaseSale,
		hideFromProduction: true,
	},
	{
		tag: 'signatories.count',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.names',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.namesPositions',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.trustee',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.attorneyInFact',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.signingOfficer',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.spouse',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.amAre',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.hasHave',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.heSheThey',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.himHerThem',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.himselfHerselfThemselves',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.hisHersTheirs',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.hisHerTheir',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.isAre',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.IWe',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.meUs',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.mineOurs',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.myOur',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.pronouns.wasWere',
		categories: ['Signatories'],
	},
	{
		tag: 'signatories.type.builder',
		categories: ['Signatories'],
		hideFromProduction: true,
	},
	{
		tag: 'signatories.type.corporation',
		categories: ['Signatories'],
		hideFromProduction: true,
	},
	{
		tag: 'signatories.type.person',
		categories: ['Signatories'],
		hideFromProduction: true,
	},
];

export const TagsMappingMap = new Map<string, TagMapping>(
	TagsMapping.map((item) => [item.tag, item]),
);
